import { render } from "./CartOverview.vue?vue&type=template&id=4501e711"
import script from "./CartOverview.vue?vue&type=script&lang=js"
export * from "./CartOverview.vue?vue&type=script&lang=js"

import "./CartOverview.vue?vue&type=style&index=0&id=4501e711&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__